import React from 'react';

import {
  DrawerOverlay as ChakraDrawerOverlay,
  forwardRef,
  useStyleConfig,
} from '@chakra-ui/react';

import { DrawerOverlayProps } from './types';

export const DrawerOverlay = forwardRef<DrawerOverlayProps, 'div'>(
  (props, ref) => {
    const styles = useStyleConfig('DrawerOverlay', { ...props });
    return <ChakraDrawerOverlay ref={ref} sx={styles} {...props} />;
  }
);
